const scaleGroupFields = [
  {
    variable: "name",
    headerName: "Group Name",
    hidden: false,
    field: "name",
  },
  {
    variable: "gre_remote",
    headerName: "GRE Remote IP",
    hidden: false,
    field: "gre_remote",
  },
  {
    variable: "metric_type",
    headerName: "Scaling Policy",
    hidden: false,
    field: "metric_type",
  },
  {
    variable: "gre_key",
    headerName: "GRE Key",
    hidden: false,
    field: "gre_key",
  },
];

class AWSDataService {
  constructor() {
    // we only need one of these
    if (!AWSDataService.instance) {
      AWSDataService.instance = this;
    }
    this.searchPlaceholder = "Search Scale Group";
  }
}

const AwsService = new AWSDataService();

export { AwsService as default, scaleGroupFields };
